<template>
  <v-card>
    <v-data-table
      :page.sync="page"
      @page-count="pageCount = $event"
      :items="students"
      :headers="headers"
      hide-default-footer
    >
      <template v-slot:item.type="{ item }">
        <span class="table-complete-name">{{item.type}}</span>
      </template>

      <template v-slot:item.session="{ item }">
        <span class="table-complete-session">{{item.session}}</span>
      </template>

      <template v-slot:item.day_date="{ item }">
        <span class="table-complete-days d-block">{{item.day}}</span>
        <span class="table-complete-days">{{item.date}}</span>
      </template>

      <template v-slot:item.time="{ item }">
        <span class="table-complete-time">{{item.time}}</span>
      </template>

      <template v-slot:item.status="{ item }">
        <span v-if="item.status" class="table-complete-status st-success">Approved</span>
        <span v-else class="table-complete-status st-error">Pending</span>
      </template>
    </v-data-table>
    <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Sessions
        <span
          :style="{'color':this.$vuetify.theme.themes.light.primary}"
        >{{students.length}}</span>
      </span>
      <v-spacer></v-spacer>
      <v-pagination circle v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-card>
</template>

<script>
import DataTableMixin from "../../../mixins/dataTable";

export default {
  name: "WorkTable",
  mixins: [DataTableMixin],
   methods: {
    makeQueryParams(){
      const user = JSON.parse(localStorage.getItem("user"));

      return {
        ...this.formQueryParams(),
        tutor:user.id,
        status: 2
      }
    },
    getItems(){
      const user = JSON.parse(localStorage.getItem("user"));

      this.loading=true
      axios.get(apiRoutes.students.catchups,{
        params:{
          username : user.username,
        }
      }).then(response=>{
        console.log(response.data.group_sessions)
        this.loading = false
        this.students = response.data.catchups
      })
    }
  },
  mounted() {

    this.getItems()
  },
  
  data() {
    return {
      dialog: false,
      page: 1,
      pageCount: 3,
      itemsPerPage: 10,
      headers: [
            { text: "Group Code", sortable: true, value: "group_session_attendance_id" },
        { text: "Student Name", value: "student.std_fname", sortable: true },
        { text: "Class", value: "group_session.group.class.class_name", sortable: true },
        { text: "Subject", value: "group_session.group.subject.subject_name", sortable: true },
        { text: "Tutor Name", value: "group_session.group.tutor.tutor_fname", sortable: true },
        { text: "Day & Date", value: "group_session.session_date", sortable: true },
        { text: "Time", value: "group_session.session_start_time", sortable: true },
        { text: "Action", value: "action", sortable: true, align: "center" }
      ],
      students: [
        {
          srno: 1,
          tutor: "John Doe",
          class: "7th",
          subject: "Math",
          session: 104,
          day: "Friday",
          date: "12-06-2020",
          time: "2:00 PM",
          status: true
        },
       
      ]
    };
  }
};
</script>

<style lang="scss">
.v-data-table-header th span {
  font: 300 14px Gotham;
  font-family: "Gotham Narrow";
  color: #8898aa;
}

.table-complete {
  &-srno {
    font: 500 14px/13px Gotham;
    color: #172b4d;
  }
  &-name {
    display: block;
    font: 500 14px/13px Gotham;
    color: #6a158e;
  }
  &-group_code {
    font: 500 14px/13px Gotham;
    color: #0ebddff7;
  }
  &-time {
    display: block;
    font: 400 14px/10px Gotham;
    color: #0e0edff7;
  }
  &-days {
    font: 400 14px/15px Gotham;
    color: #172b4db3;
  }
  &-session {
    font: 500 14px/13px Gotham;
    color: #f0cb00;
  }
  &-status {
    font: 600 14px/17px Gotham;
    color: #129b11;

    &.st-error {
      color: #e41b1bf7;
    }
  }
}
</style>